import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: string;
  rating: number;
  date?: string;
}

export default function VideoCard({ id, title, category, thumbnail, duration, views, rating, date }: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-video mb-3">
        <img
          src={thumbnail}
          alt={title}
          title={`一起草在线观看 - ${title}`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300"></div>
        <span className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded font-medium">
          {duration}
        </span>
        <div className="absolute top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-white text-lg ml-0.5"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 mb-1.5 group-hover:text-primary-500 transition-colors duration-300">
        {title}
      </h3>
      <div className="flex items-center gap-3 text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {views}
        </span>
        <span className="flex items-center gap-1">
          <i className="ri-star-fill text-amber-400 text-xs"></i>
          {rating}
        </span>
        {date && <span>{date}</span>}
      </div>
    </Link>
  );
}